import type { PublicSlotKey } from '@/apilib';
import type { DataBindingApi } from './dataBinding';

export const DataBindingApiKey: PublicSlotKey<DataBindingApi> = {
  name: 'DataBindingApi',
  public: true,
};
